import { render } from "./duruus.vue?vue&type=template&id=22856b9d"
import script from "./duruus.vue?vue&type=script&lang=js"
export * from "./duruus.vue?vue&type=script&lang=js"
script.render = render

export default script